import { render, staticRenderFns } from "./backToTopBtn.vue?vue&type=template&id=e07f33c0&scoped=true"
import script from "./backToTopBtn.vue?vue&type=script&lang=js"
export * from "./backToTopBtn.vue?vue&type=script&lang=js"
import style0 from "./backToTopBtn.vue?vue&type=style&index=0&id=e07f33c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07f33c0",
  null
  
)

export default component.exports